<template>
    <div class="max-view-header">
        <img src="@/assets/logo.png" alt="" class="header-img-left"/>
        <img src="@/assets/phone.png" alt="" class="header-img-right"/>
    </div>
</template>

<script>
  export default {}
</script>

<style lang="less" scoped>
    .max-view-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 1200px;
        height: 120px;
        margin: 0 auto;

        .header-img-left {
            height: 81px;
            width: auto;
        }

        .header-img-right {
            width: 274px;
            height: 61px;
        }
    }
</style>
